// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"oE-z","smallCardRow":"pE-z","largeCardRow":"qE-z","productSearchRow":"rE-z","curatedRow":"sE-z"};